import {User} from "./user";

export enum SubmittalStatus {
  SAMPLES_ORDERED = "SAMPLES_ORDERED",
  SUBMITTED = "SUBMITTED",
  APPROVED = "APPROVED",
  APPROVED_AS_NOTED = "APPROVED_AS_NOTED",
  REJECTED = "REJECTED",
  NOT_SUBMITTED = "NOT_SUBMITTED"
}

export enum OrderStatus {
  NOT_ORDERED = "NOT_ORDERED",
  PO_SUBMITTED = "PO_SUBMITTED",
  PARTIALLY_ORDERED = "PARTIALLY_ORDERED",
  ORDERED = "ORDERED",
  PARTIALLY_ARRIVED = "PARTIALLY_ARRIVED",
  ARRIVED = "ARRIVED"
}

export enum OrderTimelineFilter {
  ON_TRACK = "ON_TRACK",
  ORDER_OVERDUE = "ORDER_OVERDUE"
}

export enum EtaDeliveryFilter {
  ON_TIME = "ON_TIME",
  DELIVERY_DELAYED = "DELIVERY_DELAYED"
}

export class Material {
  id: number;
  version: number;
  tag: string;
  description: string;
  submittalFiles: FormFile[] = [];
  unit: MaterialUnit;
  supplier: string;
  area: string;
  submittalStatus: SubmittalStatus;
  orderStatus: OrderStatus = OrderStatus.NOT_ORDERED;
  /** Dates are ISO calendar dates ('YYYY-MM-DD'). */
  neededBy: string;
  /** Supplier lead time in days. */
  leadTime: number;
  orderedDate: string;
  arrivedDate: string;
  /** Read-only, calculated by the backend: neededBy - leadTime. */
  orderDeadline: string;
  /** Read-only, calculated by the backend: arrivedDate once Arrived, orderedDate + leadTime once ordered. */
  deliveryDate: string;
  grossQty: string;
  orderQty: string;
  paymentStatus: MaterialPaymentStatus;
  receivedQty: string;
  storedLocation: MaterialStoredLocation;
  notes: string;
  purchasingFiles: FormFile[] = [];
}

export class FormFile {
  id: number;
  name: string;
  originalFileName: string;
  sizeBytes: number;
  fileUrl: string;
  fileToSave: any;
  progress: number = 0;
  timeLeft: string = '∞';
  imgSrc: string;
  owner: User = new User();
  timestamp: number;
}

export class MaterialUnit {
  id: number;
  name: string;
  inUse: boolean;
  deletable: boolean = true;
}

export class MaterialPaymentStatus {
  id: number;
  name: string;
  inUse: boolean;
  deletable: boolean = true;
}

export class MaterialStoredLocation {
  id: number;
  name: string;
  inUse: boolean;
  deletable: boolean = true;
}
